import { render, staticRenderFns } from "./OrganisationCalendarDaily.vue?vue&type=template&id=136c5c9c&scoped=true&"
import script from "./OrganisationCalendarDaily.vue?vue&type=script&lang=ts&"
export * from "./OrganisationCalendarDaily.vue?vue&type=script&lang=ts&"
import style0 from "./OrganisationCalendarDaily.vue?vue&type=style&index=0&id=136c5c9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136c5c9c",
  null
  
)

export default component.exports